module.exports = __webpack_public_path__ + "media/images/sandbox/sonic-3eafd4baa9f600c40964dbec7e81ab05.png";